<template>
    <div class="select-none" ref="copyContainer">
        <div
            :class="
                'flex w-full items-center justify-between rounded bg-gray-50 ' +
                (hasCopied ? '!bg-primary-100 !text-primary-500' : '')
            "
        >
            <input
                class="active:focused:focus-visible:active:appearance-none active:focused:focus-visible:active:bg-transparent animated my-1 mr-0 !w-auto select-none rounded-l bg-transparent px-4 selection:bg-transparent focus:outline-none focus:ring-0"
                v-on:focus="$event.target.select()"
                ref="copyTarget"
                readonly
                :value="copiedText"
            />
            <div
                class="rounded-r p-4 text-right text-primary-500 hover:cursor-pointer hover:text-primary-400"
                @click="copyToClipboard"
            >
                <span v-if="hasCopied"> Copied </span>
                <span v-else> Copy </span>
            </div>
        </div>
        <div class="v-else"></div>
    </div>
</template>
<script>
export default {
    name: "CopyToClipboardButton",
    props: {
        copiedText: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            hasCopied: false,
        };
    },
    methods: {
        copyToClipboard() {
            let vm = this;

            vm.$refs.copyTarget.focus();
            document.execCommand("copy");
            vm.$refs.copyContainer.focus();

            vm.hasCopied = true;

            setTimeout(function () {
                vm.hasCopied = false;
            }, 1000);
        },
    },
};
</script>
